import register from '@kpsys/angularjs-register';
import LocaleDataService from './locale.data-service';

export default register('portaro.shared.components.kp-locale')
    .service(LocaleDataService.serviceName, LocaleDataService)
    .name();